import React, { useState, useEffect } from 'react'

const CgoTokenProofOfReserves = () => {
    const [isDarkMode, setIsDarkMode] = useState(
        () => document.body.className === 'darkTheme'
    );

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDarkMode(document.body.className === 'darkTheme');
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    const t = {
        textColor: isDarkMode ? '#cccccc' : '#3d3d3d',
        headingColor: isDarkMode ? '#c9a84c' : '#8B6914',
        thBg: isDarkMode ? '#2a2f45' : '#f5edd8',
        thText: isDarkMode ? '#e8d5a3' : '#5a420a',
        tdBg: isDarkMode ? '#1e2130' : '#ffffff',
        tdText: isDarkMode ? '#cccccc' : '#3d3d3d',
        borderColor: isDarkMode ? '#3a4060' : '#e0d5c1',
    };

    const customStyle = { fontWeight: 700, color: t.headingColor };

    const bulletStyle = { fontWeight: 500, marginLeft: 55, color: t.textColor };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '0.75rem',
        marginBottom: '1rem',
        fontSize: '1rem',
    };

    const thStyle = {
        padding: '0.6rem 1rem',
        border: `1px solid ${t.borderColor}`,
        fontWeight: 700,
        backgroundColor: t.thBg,
        color: t.thText,
        width: '45%',
        textAlign: 'left',
    };

    const tdStyle = {
        padding: '0.6rem 1rem',
        border: `1px solid ${t.borderColor}`,
        backgroundColor: t.tdBg,
        color: t.tdText,
    };

    return (
        <div>
            <div className="main-contain pt-5 mt-5 mb-5" style={{ textAlign: 'justify' }}>
                <section>
                    <div className="iq-banner-2">
                        <div className="banner-info">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-lg-11">
                                        <div className="banner-text iq-font-white wow fadeIn" data-wow-delay="0.1s">
                                            <h2 className="h2 text-primary">CGO Token Proof-of-Reserves Disclosure</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hero-internal-separator mt-5"></div>
                    </div>

                    <section className="iq-product-description overview-block-pt pt-0">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-11">

                                    {/* ── Purpose ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Purpose</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        This Proof-of-Reserves disclosure is intended to provide transparency regarding the physical gold reserves supporting CGO Tokens.
                                    </p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        CGO Tokens are designed to represent the value equivalent of physical gold stored in professional vault facilities.
                                    </p>

                                    {/* ── Reserve Structure ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Reserve Structure</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Each CGO Token represents the value of one gram of physical gold.
                                    </p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        The physical gold reserves supporting CGO Tokens are stored in secure vault facilities operated by professional vault custodians.
                                    </p>

                                    {/* ── Custody Information ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Custody Information</p>
                                    <table style={tableStyle}>
                                        <tbody>
                                            <tr>
                                                <th style={thStyle}>Vault Operator</th>
                                                <td style={tdStyle}>Transguard Vault Services</td>
                                            </tr>
                                            <tr>
                                                <th style={thStyle}>Vault Location</th>
                                                <td style={tdStyle}>United Arab Emirates</td>
                                            </tr>
                                            <tr>
                                                <th style={thStyle}>Gold Standard</th>
                                                <td style={tdStyle}>LBMA Good Delivery Standard</td>
                                            </tr>
                                            <tr>
                                                <th style={thStyle}>Gold Purity</th>
                                                <td style={tdStyle}>999.9 fine gold</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        The physical gold is stored in secure vault facilities and maintained under strict custody procedures designed to protect the integrity of the reserves.
                                    </p>

                                    {/* ── Reserve Ratio ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Reserve Ratio</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>The issuer intends to maintain a 1:1 reserve ratio between:</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; total CGO Tokens issued</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; total grams of physical gold held in custody</p>
                                    <p className="fs-18 mt-3" style={{ color: t.textColor }}><strong>Example structure:</strong></p>
                                    <table style={tableStyle}>
                                        <tbody>
                                            <tr>
                                                <th style={thStyle}>Total Gold Held</th>
                                                <td style={tdStyle}>47,000 grams</td>
                                            </tr>
                                            <tr>
                                                <th style={thStyle}>Total CGO Tokens Issued</th>
                                                <td style={tdStyle}>47,000</td>
                                            </tr>
                                            <tr>
                                                <th style={thStyle}>Reserve Ratio</th>
                                                <td style={tdStyle}>100%</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* ── Independent Verification ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Independent Verification</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>The issuer may conduct periodic reserve verification through:</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; internal reconciliation</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; independent audits</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; vault inventory verification</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Audit results may be published periodically to promote transparency and accountability.
                                    </p>

                                    {/* ── Blockchain Transparency ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Blockchain Transparency</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>CGO Tokens are issued on the XDC Network blockchain.</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Token supply can be independently verified through publicly available blockchain data.
                                    </p>
                                    <p className="fs-18" style={{ color: t.textColor }}>Users may verify circulating supply through blockchain explorers.</p>

                                    {/* ── Redemption Alignment ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Redemption Alignment</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        The reserve structure is intended to ensure that CGO Tokens maintain alignment with the underlying physical gold reserves, subject to operational and regulatory requirements.
                                    </p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Redemption policies may include minimum redemption quantities, identity verification requirements, and applicable logistics fees.
                                    </p>

                                    {/* ── Transparency Commitment ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Transparency Commitment</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>The issuer is committed to maintaining transparency regarding:</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; gold reserves</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; token supply</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; custody arrangements</p>
                                    <p className="fs-18" style={bulletStyle}>•&nbsp; reserve verification</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Additional information may be published periodically through transparency reports or reserve disclosures.
                                    </p>

                                    {/* ── Disclaimer ── */}
                                    <p className="mt-4 mb-2 fs-22" style={customStyle}>Disclaimer</p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        This Proof-of-Reserves disclosure is provided for informational purposes only and does not constitute financial advice or a guarantee of redemption rights. Operational, regulatory, or logistical factors may affect redemption processes.
                                    </p>
                                    <p className="fs-18" style={{ color: t.textColor }}>
                                        Users should review the CGO Risk Disclosure and Legal Disclaimer for further information.
                                    </p>

                                </div>
                            </div>
                        </div>
                    </section>

                </section>
            </div>
        </div>
    );
};

export default CgoTokenProofOfReserves;
